module.exports = __webpack_public_path__ + "static/goal-e5ef83a1881d7905a818dbe79c96063e.svg";